import { render, staticRenderFns } from "./MenusIndexPage.vue?vue&type=template&id=774eccee&scoped=true&"
import script from "./MenusIndexPage.vue?vue&type=script&lang=js&"
export * from "./MenusIndexPage.vue?vue&type=script&lang=js&"
import style0 from "./MenusIndexPage.vue?vue&type=style&index=0&id=774eccee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774eccee",
  null
  
)

export default component.exports